import '@theme/quick-add';

class ByCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button[data-step]');
      const track = this.querySelector('.by-cart-recommendations__track');
      const slide = track?.firstElementChild;
      if (!button || !track || !slide) return;
      const step = Number(button.dataset.step);
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({
        left: (slide.getBoundingClientRect().width + gap) * step,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }, options);
    this.addEventListener('scroll', this.updateButtons, { ...options, capture: true, passive: true });
    this.observer = new ResizeObserver(this.updateButtons);
    this.observer.observe(this);
    this.updateButtons();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }

  updateButtons = () => {
    const track = this.querySelector('.by-cart-recommendations__track');
    if (!track) return;
    const previous = this.querySelector('[data-step="-1"]');
    const next = this.querySelector('[data-step="1"]');
    if (previous) previous.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
}

if (!customElements.get('by-cart-recommendations')) {
  customElements.define('by-cart-recommendations', ByCartRecommendations);
}
